export default __webpack_public_path__ + "static/media/graignes10.76f1b1f5.jpg";